import { useEffect, useState } from 'react'
import { Box, Button, Drawer } from '@mui/material'
import { BasePathProvider } from 'components/Providers'
import { useNavigate, useParams } from 'react-router-dom'
import AssignAssetList from './List'
import Filters from 'components/Filters'
import { FaPlus } from "react-icons/fa";
import { useDispatch, useSelector } from 'react-redux'
import { search as searchAssets, setSearchApplicationQuery } from 'store/asset/asset-assign'
import AssignAssetFormIndex from './Form'
import { getVendors } from 'store/lookup'
import { useSession } from 'components/Providers'

const baseUrl = '/asset-management/my-devices'

export default function AssignAssetPage() {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const { id } = useParams()
    const { district } = useSession()
    const [filterValues, setFilterValues] = useState({})
    const types = useSelector(state => state.lookup.types)
    const assetCondition = types?.filter(type => type.category === 'assetConditionType') || []
    const assetStatus = types?.filter(type => type.category === 'assetStatusType') || []
    const assetType = types?.filter(type => type.category === 'assetType') || []
    const vendors = useSelector(state => state.lookup.vendors)
    const campus = useSelector(state => state.lookup.campus?.filter(c => ['provider', 'school'].includes(c.type)))
    const defaultCampus = campus?.find(c => c.name?.includes('iLearn')) || null

    useEffect(() => {
        if (!vendors) dispatch(getVendors())
    }, [vendors, dispatch])

    const campusReady = !district?.isServiceProvider || Array.isArray(campus)

    const filters = [
        ...(district?.isServiceProvider ? [{
            key: 'campusId',
            label: 'Campus',
            type: 'autocomplete',
            minClearLength: 3,
            clearableWhenKey: 'que',
            gridProps: { xs: 12, sm: 6, md: 12 },
        }] : []),
        {
            key: 'typeId',
            label: 'Types',
            type: 'autocomplete',
            gridProps: { xs: 12, sm: 6, md: 2 },
        },
        {
            key: 'conditionId',
            label: 'Condition',
            type: 'autocomplete',
            gridProps: { xs: 12, sm: 6, md: 2 },
        },
        {
            key: 'statusId',
            label: 'Status',
            type: 'autocomplete',
            gridProps: { xs: 12, sm: 6, md: 2 },
        },
        {
            key: 'assigneeType',
            label: 'Assignee Types',
            type: 'autocomplete',
            options: [
                { value: 'student', label: 'Student' },
                { value: 'staff', label: 'Staff' },
                { value: 'room', label: 'Room' },
            ],
            gridProps: { xs: 12, sm: 6, md: 2 },
        },
        {
            key: 'que',
            label: 'Search...',
            type: 'text',
            gridProps: { xs: 12, sm: 6, md: 2 }
        },
        {
            key: 'inRepair',
            label: 'In Repair',
            type: 'checkbox',
            omitWhenFalse: true,
            gridProps: { xs: 12, sm: 6, md: 2 }
        },
    ]

    const optionsMap = {
        typeId: assetType?.map(t => ({ value: t.code, label: t.name })),
        conditionId: assetCondition?.map(t => ({ value: t.code, label: t.name })),
        statusId: assetStatus?.map(t => ({ value: t.code, label: t.name })),
        campusId: campus?.map(c => ({ value: c.id, label: c.name })),
    }

    return (
        <Box>
            <BasePathProvider value={`${baseUrl}`}>
                <Box p={1} mt={1} display="flex" justifyContent="flex-end" gap={1}>
                    <Button variant='contained' startIcon={<FaPlus />} onClick={() => navigate(`${baseUrl}/new`)}>Add Asset</Button>
                </Box>
                {campusReady && <Filters
                    filtersConfig={filters}
                    values={filterValues}
                    onChange={setFilterValues}
                    optionsMap={optionsMap}
                    api={{
                        search: searchAssets,
                        setQuery: setSearchApplicationQuery,
                        querySelector: state => state.asset.assetManagement.query,
                    }}
                    defaultQuery={district?.isServiceProvider && defaultCampus ? { campusId: defaultCampus.id } : {}}
                    gridContainerProps={{ spacing: 2, px: 1, sx: { my: 1 } }}
                />}
                <AssignAssetList />
                <Drawer
                    PaperProps={{
                        sx: {
                            width: window.location.pathname.includes('logs') ? 1000 : 800,
                        },
                    }}
                    open={Boolean(id)}
                    anchor="right"
                    onClose={() => navigate(baseUrl)}
                >
                    <AssignAssetFormIndex assetType={assetType} vendors={vendors} assetCondition={assetCondition} />
                </Drawer>
            </BasePathProvider>
        </Box>
    )
}
